function initializeUnpack(section) {
  if (!section || section.dataset.initialized) return;
  section.dataset.initialized = "true";
  const scene = section.querySelector('.unpack-scene');
  const pouch = section.querySelector('.unpack-pouch');
  const lid = section.querySelector('.unpack-lid');
  const cube = section.querySelector('.unpack-cube');
  const slider = section.querySelector('#unpack-slider');
  const status = section.querySelector('#unpack-status');
  const chapters = [...section.querySelectorAll('[data-chapter]')];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = n => Math.max(0, Math.min(1, n));
  const phase = (p, start, end) => clamp((p - start) / (end - start));
  const ease = n => n * n * (3 - 2 * n);
  const mix = (a, b, t) => a + (b - a) * t;
  let queued = false;
  let previousChapter = -1;

  function render(progress) {
    const p = clamp(progress);
    const tear = ease(phase(p, .05, .32));
    const emerge = ease(phase(p, .29, .66));
    const finish = ease(phase(p, .65, .94));
    const w = scene.clientWidth;
    const h = scene.clientHeight;
    const compact = w < 580;
    const bagHeight = Math.min(h * .83, compact ? 340 : 390);
    const bagWidth = bagHeight * 720 / 896;
    const bagX = (w - bagWidth) / 2;
    const bagY = (h - bagHeight) / 2 + h * .025;
    const cubeSize = Math.max(80, Math.min(compact ? w * .85 : w * .46, compact ? (h - 72) * .96 : h * .96, 470));
    const startScale = bagWidth * .57 / cubeSize;
    const cubeX = (w - cubeSize) / 2;
    const cubeStartY = bagY + bagHeight * .4 - cubeSize / 2;
    const cubeExitY = bagY - cubeSize * .25;
    const cubeEndY = compact ? Math.max(0, (h - 74 - cubeSize) / 2) : (h - cubeSize) / 2;
    const cubeY = mix(mix(cubeStartY, cubeExitY, emerge), cubeEndY, finish);
    const scale = mix(mix(startScale, .62, emerge), 1, finish);

    section.style.setProperty('--tear', tear.toFixed(4));
    section.style.setProperty('--reveal', emerge.toFixed(4));
    section.style.setProperty('--finish', finish.toFixed(4));
    section.style.setProperty('--progress', p.toFixed(4));
    for (const layer of [pouch, lid]) {
      layer.style.width = `${bagWidth}px`;
      layer.style.height = `${bagHeight}px`;
    }
    pouch.style.transform = `translate(${bagX}px, ${bagY + emerge * h * .22 + finish * h * .65}px) rotate(${emerge * 4 - finish * 9}deg)`;
    pouch.style.opacity = (1 - finish).toFixed(4);
    lid.style.transformOrigin = '12% 10%';
    lid.style.transform = `translate(${bagX + tear * bagWidth * .65}px, ${bagY - tear * bagHeight * .19}px) rotate(${tear * -24}deg)`;
    lid.style.opacity = (1 - ease(phase(p, .30, .53))).toFixed(4);
    cube.style.width = `${cubeSize}px`;
    cube.style.height = `${cubeSize}px`;
    cube.style.transform = `translate(${cubeX}px, ${cubeY}px) rotate(${mix(-17, -8, emerge) + finish * 8}deg) scale(${scale})`;
    cube.style.opacity = ease(phase(p, .24, .38)).toFixed(4);
    slider.value = String(Math.round(p * 100));

    const chapter = p < .33 ? 0 : p < .71 ? 1 : 2;
    if (chapter !== previousChapter) {
      const labels = ['SCROLL TO TEAR IT OPEN ↓', 'HERE COMES YOUR COFFEE ↓', 'ONE CUBE. NO POWDER.'];
      const values = ['Sealed pack, tear to open', 'Pack opening, coffee cube emerging', 'Single coffee cube close-up'];
      status.textContent = labels[chapter];
      slider.setAttribute('aria-valuetext', values[chapter]);
      section.querySelector('#unpack-title').setAttribute('aria-label', chapter === 2 ? 'No scoop. No measuring.' : 'Not powder. A cube.');
      chapters.forEach((el, index) => el.classList.toggle('active', index === chapter));
      section.dataset.phase = ['tear', 'reveal', 'closeup'][chapter];
      previousChapter = chapter;
    }
  }

  function update() {
    queued = false;
    const distance = section.offsetHeight - window.innerHeight;
    render(reduced.matches ? 1 : -section.getBoundingClientRect().top / Math.max(1, distance));
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  function updateMotion() {
    section.classList.toggle('unpack-static', reduced.matches);
    schedule();
  }
  slider.addEventListener('input', () => {
    const progress = Number(slider.value) / 100;
    const start = window.scrollY + section.getBoundingClientRect().top;
    const distance = section.offsetHeight - window.innerHeight;
    window.scrollTo({ top: start + progress * Math.max(1, distance), behavior: 'instant' });
    render(progress);
  });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  reduced.addEventListener('change', updateMotion);
  const resizeObserver = new ResizeObserver(schedule);
  resizeObserver.observe(scene);
  section.ohsipCleanup = () => { window.removeEventListener("scroll", schedule); window.removeEventListener("resize", schedule); reduced.removeEventListener("change", updateMotion); resizeObserver.disconnect(); };
  updateMotion();
 }
function initializeAll(container=document) { container.querySelectorAll('[data-ohsip-home] .unpack').forEach(initializeUnpack); }
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initializeAll()); else initializeAll();
document.addEventListener('shopify:section:load',event=>initializeAll(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.unpack').forEach(section=>section.ohsipCleanup?.()));
